import { notifications } from "@mantine/notifications";
import { IconX } from "@tabler/icons-react";

export const ErrorNotification = (description: string) => {
  notifications.show({
    title: "Error",
    message: description,
    color: "red",
    icon: <IconX />
  });
};
